module.exports = __webpack_public_path__ + "fontoctopus.5eed1ba76b15097fa82835184a007327.hashedasset.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/fontoctopus/fontoctopus.ttf
// module id = 440
// module chunks = 8